import { Box } from '@mui/material';

type AppBannerContainerProps = {
  children: React.ReactNode;
};

/** Shared layout for banners rendered above the application routes. */
export const AppBannerContainer = ({ children }: AppBannerContainerProps) => (
  <Box
    sx={{
      px: { xs: 2, sm: 3 },
      pt: 2,
      maxWidth: 1400,
      margin: '0 auto',
      width: '100%',
    }}
  >
    {children}
  </Box>
);
